import { Injectable } from '@angular/core';
import {
  DateRange,
  MatDateRangeSelectionStrategy,
} from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';

@Injectable()
export class EntireWeekRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D>
{
  constructor(private _dateAdapter: DateAdapter<D>) {}

  selectionFinished(date: D | null): DateRange<D> {
    return this._createWeekRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createWeekRange(activeDate);
  }

  private _createWeekRange(date: D | null): DateRange<D> {
    if (date) {
      const dayOfWeek = this._dateAdapter.getDayOfWeek(date);

      // Sunday (dayOfWeek = 0) is defined in app as last day of week, but DateAdapter considers it as first day of week
      // So we need to calculate start and end of week for this case in a different way
      if (!dayOfWeek) {
        const startOfWeek = this._dateAdapter.addCalendarDays(date, -6);
        return new DateRange<D>(startOfWeek, date);
      }

      const startOfWeek = this._dateAdapter.addCalendarDays(
        date,
        1 - dayOfWeek
      );
      const endOfWeek = this._dateAdapter.addCalendarDays(startOfWeek, 6);
      return new DateRange<D>(startOfWeek, endOfWeek);
    }

    return new DateRange<D>(null, null);
  }
}
